import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import CompaniesList from './CompaniesList'

export default function Companies() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/companies" component={CompaniesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}